var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2507_1309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.89529 17.6264C10.2629 17.6264 12.1822 15.6892 12.1822 13.2995C12.1822 10.9099 10.2629 8.97266 7.89529 8.97266C5.52771 8.97266 3.6084 10.9099 3.6084 13.2995C3.6084 15.6892 5.52771 17.6264 7.89529 17.6264Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1043 24.0934C15.1043 20.7237 12.398 17.9922 9.05952 17.9922H6.7156C3.37707 17.9922 0.670776 20.7237 0.670776 24.0934V25.3463C0.670776 26.2723 1.11797 27.1595 1.90441 27.642C3.64693 28.7081 5.69785 29.3229 7.88756 29.3229C10.0773 29.3229 12.1205 28.7081 13.863 27.642C14.6494 27.1595 15.0966 26.2723 15.0966 25.3463V24.0934H15.1043Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38713 23.1597L3.23059 28.3348",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5368 28.3348L11.3726 23.1597",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40417 8.73163V4.87949C8.40417 2.6149 10.2238 0.77832 12.4675 0.77832H38.1657C40.4094 0.77832 42.229 2.6149 42.229 4.87949V22.7705C42.229 25.0351 40.4094 26.8717 38.1657 26.8717H14.8885",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 21L36 21",
    stroke: "#106B46",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 15L36 15",
    stroke: "#106B46",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 9L36 9",
    stroke: "#106B46",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2507_1309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9613 10.0588C18.0756 10.1736 18.2305 10.2381 18.392 10.2381C18.5535 10.2381 18.7084 10.1736 18.8227 10.0588L20.8216 8.04725C20.9311 7.93121 20.9913 7.77669 20.9892 7.61665C20.9872 7.4566 20.9231 7.30369 20.8107 7.19051C20.6982 7.07733 20.5463 7.01284 20.3872 7.01079C20.2282 7.00874 20.0747 7.0693 19.9594 7.17954L18.3889 8.75461L18.0406 8.40399C17.9848 8.3433 17.9175 8.29454 17.8426 8.26066C17.7678 8.22677 17.6869 8.20845 17.6048 8.20679C17.5227 8.20514 17.4411 8.22018 17.3649 8.25101C17.2888 8.28185 17.2196 8.32785 17.1615 8.38625C17.1034 8.44465 17.0576 8.51425 17.0269 8.59088C16.9962 8.66751 16.9812 8.74959 16.9828 8.8322C16.9844 8.91481 17.0025 8.99625 17.0361 9.07164C17.0697 9.14703 17.1181 9.21482 17.1783 9.27093L17.9613 10.0588Z",
    fill: "#106B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9613 16.0473C18.017 16.1057 18.0839 16.1521 18.1579 16.1838C18.232 16.2155 18.3116 16.2318 18.392 16.2318C18.4724 16.2318 18.552 16.2155 18.6261 16.1838C18.7001 16.1521 18.767 16.1057 18.8227 16.0473L20.8216 14.0365C20.9311 13.9205 20.9913 13.766 20.9893 13.6059C20.9872 13.4459 20.9231 13.2929 20.8107 13.1798C20.6982 13.0666 20.5463 13.0021 20.3872 13.0001C20.2282 12.998 20.0747 13.0586 19.9594 13.1688L18.3889 14.7431L18.0406 14.3925C17.9261 14.2774 17.771 14.2128 17.6092 14.2129C17.4474 14.213 17.2923 14.2777 17.178 14.3929C17.0636 14.508 16.9994 14.6642 16.9995 14.827C16.9996 14.9898 17.0639 15.1459 17.1784 15.261L17.9613 16.0473Z",
    fill: "#106B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9613 22.0658C18.0756 22.1806 18.2305 22.2451 18.392 22.2451C18.5535 22.2451 18.7084 22.1806 18.8227 22.0658L20.8216 20.0535C20.9359 19.9371 21 19.7801 21 19.6165C21 19.453 20.9359 19.296 20.8216 19.1796C20.7072 19.0646 20.5522 19 20.3905 19C20.2288 19 20.0737 19.0646 19.9594 19.1796L18.3889 20.7547L18.0406 20.4041C17.9261 20.289 17.771 20.2244 17.6092 20.2245C17.4474 20.2246 17.2923 20.2893 17.178 20.4045C17.0636 20.5196 16.9994 20.6758 16.9995 20.8386C16.9996 21.0014 17.0639 21.1575 17.1784 21.2726L17.9613 22.0658Z",
    fill: "#106B46"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2507_1309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2507_1309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    fill: "white",
    transform: "translate(17 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.575f72293d02cbd873b253c4a3fe4229.svg";
export { ForwardRef as ReactComponent };